import { Text } from '@payaca/ambrosia';
import { FC } from 'react';

import { DocumentBlueprintsTable } from '@/ui/components/documentBlueprints/DocumentBlueprintsTable';

/** The Ready-made library settings section, rendered in the Company Settings pane. */
export const ReadyMadeLibrarySettings: FC = () => {
  return (
    <div className="p-4">
      <div className="mb-4">
        <Text colour="muted">
          Ready-to-use commissioning certificates, service records, site surveys
          and safety checklists. Adding one sets up the Document template and
          the Project custom fields it needs.
        </Text>
      </div>
      <DocumentBlueprintsTable />
    </div>
  );
};
